import { render, staticRenderFns } from "./auth-subpage.vue?vue&type=template&id=4f5be834&lang=pug&"
import script from "./auth-subpage.vue?vue&type=script&lang=js&"
export * from "./auth-subpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports